import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { ButtonVariant } from "Constant/button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

import useHostFooterAction from "components/organisms/CreationModal/hooks/useHostFooterAction";

import MouseOverPopover from "../../components/MouseOverPopover";
import "../../css/createSourceModal.css";
import { sendFreshSalesData } from "../../helpers/Sources/freshSale/freshSales";
import StandartButton from "../atoms/StandartButton";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import SwalAlertComp from "../SwalAlert";

const FreshsalesSource = ({
    handleClose,
    handleGetSources,
    getTracker,
    addToTracker,
    getAllSourcesReduxProps,
    setNextCheck,
    selectFileSourceId,
    setLoading,
    setIsMappingSuccessfull,
    isModal,
    useHostFooter = false,
    registerFooterAction,
}) => {
    const [freshSaleInput, setFreshSaleInput] = useState({
        freshName: "",
        freshApiKey: "",
        bundle_alias: "",
    });
    const [freshSourceID, setFreshSourceID] = useState("");
    const [btnCheck, setBtnCheck] = useState(true);
    const [freshData, setFreshData] = useState(null);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        freshName: "",
        freshApiKey: "",
        bundle_alias: "",
    });
    const language = useSelector((state) => state.languagesState.languages);

    const setLoadingState = (loading) => {
        setIsSaveLoading(loading);
        setLoading?.(loading);
    };

    const handleCloseModal = () => {
        handleClose?.();
        setBtnCheck(false);
    };

    const popoverFreshsales = (
        <div>
            In your FreshSales dashboard, go to the following sections in order:
            <strong className="mx-2">
                {" "}
                <ul style={{ marginLeft: "15px", listStyleType: "auto" }}>
                    <li>Admin Settings</li>
                    <li>Website Tracking and APIs</li>
                    <li>API Settings</li>
                    <li>API Authentication</li>
                </ul>
            </strong>
            <br></br>
            After completing the recaptcha step under the API Authentication
            section, you can obtain your API Key and Bundle Alias codes.
        </div>
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFreshSaleInput({ ...freshSaleInput, [name]: value });
        setErrorMessages({
            ...errorMessages,
            [name]: value ? "" : "Cannot be blank!",
        });
    };

    const fetchFreshSalesData = async () => {
        if (
            !freshSaleInput.freshName ||
            !freshSaleInput.freshApiKey ||
            !freshSaleInput.bundle_alias
        ) {
            setErrorMessages({
                freshName:
                    freshSaleInput.freshName === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                freshApiKey:
                    freshSaleInput.freshApiKey === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                bundle_alias:
                    freshSaleInput.bundle_alias === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
            });
            return;
        }

        setLoadingState(true);
        let data = {
            name: freshSaleInput?.freshName,
            usage_types: [4],
            freshsales_domain: freshSaleInput?.bundle_alias,
            freshsales_api_key: freshSaleInput?.freshApiKey,
        };
        let response = await sendFreshSalesData(data);
        if (response.status) {
            setFreshData(response?.data?.field_data?.fields);
            if (selectFileSourceId) {
                selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
            setBtnCheck(false);
            setFreshSourceID(response?.data?.source?.id);
            setLoadingState(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            setLoadingState(false);
        }
    };

    const saveCrmMapping = (response) => {
        setIsMappingSuccessfull?.(true);
        setLoadingState(true);
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            handleClose?.(freshSourceID);
            if (handleGetSources) {
                handleGetSources();
            }
            if (getTracker) {
                addToTracker(freshSourceID);
            }
            if (getAllSourcesReduxProps) {
                getAllSourcesReduxProps();
            }
            if (setNextCheck) {
                setNextCheck(true);
            }
            setFreshSourceID("");
            setBtnCheck(false);
            setLoadingState(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            setLoadingState(false);
        }
    };

    useHostFooterAction(registerFooterAction, "form", {
        label: language?.buttons?.continue ?? "Continue",
        onSubmit: fetchFreshSalesData,
        isLoading: isSaveLoading,
        hidden: !!freshData,
    });

    const saveButton = (
        <StandartButton
            variant="contained"
            color="primary"
            onClick={fetchFreshSalesData}
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
            wrapperSx={{ marginLeft: "auto", width: "fit-content" }}
        >
            Create Source
        </StandartButton>
    );

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {freshData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={freshSourceID}
                            sourceType={"freshsales"}
                            mappingSuccess={saveCrmMapping}
                            isModal={isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        ></CrmSourceMappingArea>
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={!!errorMessages?.freshName}
                        >
                            <TextField
                                name="freshName"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.name ?? "Name"
                                }
                                value={freshSaleInput?.freshName}
                                error={!!errorMessages?.freshName}
                            />
                            {errorMessages?.freshName && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.freshName}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3 mouse-over-popover-area"
                            style={{ width: "100%" }}
                            error={!!errorMessages?.freshApiKey}
                        >
                            <TextField
                                name="freshApiKey"
                                label={
                                    language?.source_modal?.api_key ?? "API KEY"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.api_key ?? "API KEY"
                                }
                                value={freshSaleInput?.freshApiKey}
                                error={!!errorMessages?.freshApiKey}
                            />
                            {errorMessages?.freshApiKey && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.freshApiKey}
                                </div>
                            )}
                            <MouseOverPopover
                                text={popoverFreshsales}
                            ></MouseOverPopover>
                        </FormControl>

                        <FormControl
                            className="mb-3 mouse-over-popover-area"
                            style={{ width: "100%" }}
                            error={!!errorMessages?.bundle_alias}
                        >
                            <TextField
                                name="bundle_alias"
                                label={
                                    language?.source_modal?.bundle_alias ??
                                    "Bundle Alias"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.bundle_alias ??
                                    "Bundle Alias"
                                }
                                value={freshSaleInput?.bundle_alias}
                                error={!!errorMessages?.bundle_alias}
                            />
                            {errorMessages?.bundle_alias && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.bundle_alias}
                                </div>
                            )}
                            <MouseOverPopover
                                text={popoverFreshsales}
                            ></MouseOverPopover>
                        </FormControl>
                    </>
                )}
            </Form.Group>

            {!useHostFooter &&
                btnCheck &&
                (isModal ? (
                    <Modal.Footer className="source-modal-footer">
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={handleCloseModal}
                            disabled={isSaveLoading}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </StandartButton>
                        {saveButton}
                    </Modal.Footer>
                ) : (
                    saveButton
                ))}
        </div>
    );
};

export default FreshsalesSource;
